export default "__VITE_ASSET__715db15c__"